/* ============================================================
   HAMBURGER DRAWER - JavaScript Controller
   ============================================================ */

(function () {
  'use strict';

  var DEBUG = true; // Set to false in production

  function log() {
    if (DEBUG) {
      var args = ['[HamburgerDrawer]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  var SELECTORS = {
    dialog: '.hamburger-drawer__dialog',
    trigger: '.js-mobile-draw-trigger',
    close: '.js-hamburger-drawer-close'
  };

  var CLASSES = {
    open: 'ts-open',
    close: 'ts-close',
    bodyLock: 'hamburger-drawer--body-lock'
  };

  var dialog = null;
  var isClosing = false;
  var closeTimeout = null;
  var savedScrollY = 0;

  function init() {
    dialog = document.querySelector(SELECTORS.dialog);
    log('init() called. Dialog found:', !!dialog);

    if (!dialog) {
      log('ERROR: Dialog element not found with selector:', SELECTORS.dialog);
      return;
    }

    log('Dialog tagName:', dialog.tagName);
    log('Dialog supports showModal:', typeof dialog.showModal === 'function');

    var closeBtn = dialog.querySelector(SELECTORS.close);
    log('Close button found:', !!closeBtn);

    // Check trigger elements
    var triggers = document.querySelectorAll(SELECTORS.trigger);
    log('Trigger elements found:', triggers.length);
    for (var i = 0; i < triggers.length; i++) {
      var t = triggers[i];
      var parentIcon = t.closest('.js-mobile-draw-icon');
      log('Trigger ' + i + ' - parentDisplay:', parentIcon ? parentIcon.style.display : 'no-parent');
    }

    // Verify dialog is hidden on load
    log('Dialog open attribute on load:', dialog.hasAttribute('open'));
    log('Dialog display on load:', window.getComputedStyle(dialog).display);

    // --- OPEN: Capture-phase click on document ---
    // This fires BEFORE jQuery's delegated bubble-phase handler (desktop clicks)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(SELECTORS.trigger);
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        log('Trigger clicked (capture phase) - opening drawer');
        openDrawer();
      }
    }, true);

    // --- OPEN: Capture-phase touchend on document ---
    // BUG FIX: On mobile, touchend fires BEFORE click. If we preventDefault()
    // on touchend, the browser suppresses the subsequent click event entirely.
    // So we MUST also call openDrawer() here for touch devices.
    document.addEventListener('touchend', function (e) {
      var trigger = e.target.closest(SELECTORS.trigger);
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        log('Trigger touchend - opening drawer');
        openDrawer();
      }
    }, true);

    // --- Neutralize old jQuery MagnificPopup handler ---
    // The old theme.js binds: $(document).on("click touchend", ".js-mobile-draw-trigger", ...)
    // which calls theme.mfpOpen("menu-draw") targeting the removed .js-menu-draw element.
    function removeOldJQueryHandler() {
      if (window.jQuery) {
        try {
          jQuery(document).off('click touchend', SELECTORS.trigger);
          log('Old jQuery handler for trigger removed');
        } catch (err) {
          log('Could not remove old jQuery handler:', err.message);
        }
      }
    }
    // Try immediately and also on window load (in case jQuery loads later)
    removeOldJQueryHandler();
    window.addEventListener('load', removeOldJQueryHandler);

    // --- CLOSE: X button + backdrop click ---
    dialog.addEventListener('click', function (e) {
      // Check if close button was clicked
      var closeBtnClicked = e.target.closest(SELECTORS.close);
      if (closeBtnClicked) {
        e.preventDefault();
        e.stopPropagation();
        log('Close button clicked');
        closeDrawer();
        return;
      }

      // Check if backdrop was clicked (click on dialog element itself)
      if (e.target === dialog) {
        log('Backdrop clicked');
        closeDrawer();
      }
    });

    // --- CLOSE: Escape key (native dialog cancel event) ---
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      log('Cancel event (Escape key)');
      closeDrawer();
    });

    // --- Animation end handler for close ---
    dialog.addEventListener('animationend', function (e) {
      if (e.target !== dialog) return; // Ignore child animations
      log('animationend fired. isClosing:', isClosing, 'animationName:', e.animationName);
      if (isClosing) {
        finishClose();
      }
    });

    log('All event listeners attached successfully');
  }

  function openDrawer() {
    if (!dialog) {
      log('ERROR: openDrawer() called but dialog is null');
      return;
    }
    log('openDrawer() called. Dialog state - open:', dialog.open, 'hasOpenAttr:', dialog.hasAttribute('open'));

    // Guard against double-open (touchend + click can both fire on some devices)
    if (dialog.open) {
      log('Dialog already open, skipping');
      return;
    }

    // If we're mid-close, finish it first
    if (isClosing) {
      log('Was mid-close, finishing close first');
      finishClose();
    }

    isClosing = false;
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }

    dialog.classList.remove(CLASSES.close);
    dialog.classList.add(CLASSES.open);
    savedScrollY = window.scrollY;
    document.body.classList.add(CLASSES.bodyLock);
    document.body.style.top = '-' + savedScrollY + 'px';

    try {
      dialog.showModal();
      log('showModal() SUCCESS. Dialog open:', dialog.open, 'display:', window.getComputedStyle(dialog).display);
    } catch (err) {
      log('showModal() ERROR:', err.message);
      // Fallback: manually set open attribute
      try {
        dialog.setAttribute('open', '');
        log('Fallback: set open attr. Display:', window.getComputedStyle(dialog).display);
      } catch (err2) {
        log('Fallback also failed:', err2.message);
      }
    }

    // Focus close button for keyboard users
    var closeBtn = dialog.querySelector(SELECTORS.close);
    if (closeBtn) {
      setTimeout(function () {
        closeBtn.focus();
      }, 100);
    }
  }

  function closeDrawer() {
    if (!dialog) return;
    if (isClosing) {
      log('closeDrawer() called but already closing, skipping');
      return;
    }

    log('closeDrawer() called. Dialog open:', dialog.open);
    isClosing = true;

    // Add close animation class
    dialog.classList.remove(CLASSES.open);
    dialog.classList.add(CLASSES.close);

    // Fallback: if animationend doesn't fire within 600ms, force close
    closeTimeout = setTimeout(function () {
      if (isClosing) {
        log('Close timeout fallback triggered (animation may not have fired)');
        finishClose();
      }
    }, 600);
  }

  function finishClose() {
    log('finishClose() called');

    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }

    // Actually close the dialog
    if (dialog && dialog.open) {
      try {
        dialog.close();
        log('dialog.close() SUCCESS. Dialog open:', dialog.open);
      } catch (err) {
        log('dialog.close() ERROR:', err.message);
        // Force remove open attribute as fallback
        dialog.removeAttribute('open');
        log('Forced removal of open attribute');
      }
    }

    // Clean up classes
    if (dialog) {
      dialog.classList.remove(CLASSES.close);
      dialog.classList.remove(CLASSES.open);
    }
    document.body.classList.remove(CLASSES.bodyLock);
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
    isClosing = false;
    log('Close complete. Dialog open:', dialog ? dialog.open : 'N/A');
  }

  // Expose globally for debugging
  window.hamburgerDrawer = {
    open: openDrawer,
    close: closeDrawer,
    debugChevrons: function () {
      console.log('=== CHEVRON DIAGNOSTIC ===');

      // Check L1 accordions (details > summary)
      var l1Accordions = document.querySelectorAll('.hamburger-drawer__l1-item details');
      console.log('L1 accordions (details elements):', l1Accordions.length);

      // Check L2 items - ALL of them
      var l2Items = document.querySelectorAll('.hamburger-drawer__l2-item');
      console.log('L2 items (total):', l2Items.length);

      // Check which L2 items are accordions vs simple links
      var l2Accordions = document.querySelectorAll('.hamburger-drawer__l2-item details, details.hamburger-drawer__l2-item');
      var l2Links = document.querySelectorAll('div.hamburger-drawer__l2-item');
      console.log('L2 as ACCORDION (details):', l2Accordions.length);
      console.log('L2 as SIMPLE LINK (div > a):', l2Links.length);

      // Check for ANY chevron in the drawer
      var allChevrons = document.querySelectorAll('.hamburger-drawer__dialog .hamburger-drawer__chevron');
      console.log('Total chevrons in drawer:', allChevrons.length);

      // Check L2 summaries specifically
      var l2Summaries = document.querySelectorAll('.hamburger-drawer__l2-link');
      l2Summaries.forEach(function (el, i) {
        var tagName = el.tagName;
        var chevron = el.querySelector('.hamburger-drawer__chevron');
        console.log('L2 link ' + i + ': tag=' + tagName + ', text="' + el.textContent.trim().substring(0, 30) + '", hasChevron=' + !!chevron);
      });

      // Deep style check on the first L2 chevron
      var firstL2Summary = document.querySelector('details.hamburger-drawer__l2-item summary');
      if (firstL2Summary) {
        var summaryStyles = window.getComputedStyle(firstL2Summary);
        console.log('\n--- FIRST L2 SUMMARY COMPUTED STYLES ---');
        console.log('tag:', firstL2Summary.tagName);
        console.log('display:', summaryStyles.display);
        console.log('flexDirection:', summaryStyles.flexDirection);
        console.log('width:', summaryStyles.width);
        console.log('overflow:', summaryStyles.overflow);

        var span = firstL2Summary.querySelector('.hamburger-drawer__summary-content');
        if (span) {
          var spanStyles = window.getComputedStyle(span);
          console.log('\n--- SPAN WRAPPER STYLES ---');
          console.log('exists: YES');
          console.log('display:', spanStyles.display);
          console.log('width:', spanStyles.width);
          console.log('justifyContent:', spanStyles.justifyContent);
        } else {
          console.log('\n--- SPAN WRAPPER: NOT FOUND (old HTML without span) ---');
        }

        var chevron = firstL2Summary.querySelector('.hamburger-drawer__chevron');
        if (chevron) {
          var chevStyles = window.getComputedStyle(chevron);
          console.log('\n--- CHEVRON COMPUTED STYLES ---');
          console.log('display:', chevStyles.display);
          console.log('visibility:', chevStyles.visibility);
          console.log('opacity:', chevStyles.opacity);
          console.log('width:', chevStyles.width);
          console.log('height:', chevStyles.height);
          console.log('overflow:', chevStyles.overflow);
          console.log('color:', chevStyles.color);
          console.log('position:', chevStyles.position);
          console.log('getBoundingClientRect:', JSON.stringify(chevron.getBoundingClientRect()));
        }
      }

      console.log('=== END CHEVRON DIAGNOSTIC ===');
    },
    debug: function () {
      console.log('=== [HamburgerDrawer] DIAGNOSTIC DUMP ===');
      console.log('Dialog element:', dialog);
      console.log('Dialog tagName:', dialog ? dialog.tagName : 'N/A');
      console.log('Dialog open:', dialog ? dialog.open : 'N/A');
      console.log('Dialog display:', dialog ? window.getComputedStyle(dialog).display : 'N/A');
      console.log('Dialog classes:', dialog ? dialog.className : 'N/A');
      console.log('isClosing:', isClosing);
      console.log('Body has lock class:', document.body.classList.contains(CLASSES.bodyLock));
      var triggers = document.querySelectorAll(SELECTORS.trigger);
      console.log('Trigger elements found:', triggers.length);
      for (var i = 0; i < triggers.length; i++) {
        var t = triggers[i];
        var parent = t.closest('.js-mobile-draw-icon');
        console.log('  Trigger ' + i + ':', {
          visible: t.offsetParent !== null,
          display: window.getComputedStyle(t).display,
          parentDisplay: parent ? parent.style.display : 'no-parent',
          href: t.getAttribute('href')
        });
      }
      console.log('jQuery loaded:', !!window.jQuery);
      if (window.jQuery) {
        var events = jQuery._data(document, 'events');
        if (events && events.click) {
          console.log('jQuery click handlers on document:', events.click.length);
        }
      }
      console.log('=== END DIAGNOSTIC ===');
    }
  };

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
